var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"droppable",class:{'over' : _vm.over, 'dropped' : _vm.dropped, 'inactive' : !_vm.active},attrs:{"data-type":_vm.accept},on:{"drop":_vm.drop,"dragover":_vm.dragover,"dragenter":_vm.dragenter,"dragleave":_vm.dragout}})}
var staticRenderFns = []

export { render, staticRenderFns }